import Notfound from "pages/Fallback/Notfound"
import React from "react"
import { Redirect } from "react-router-dom"
// Profile

import {
  AddNewCreativeLazy,
  AdGroupsLazy,
  AllCreativesLazy,
  AnalyticsLazy,
  BillingLazy,
  CampaignsPageLazy,
  CampaignSummaryLazy,
  AdminChangeLogsLazy,
  ChangeLogsLazy,
  CreateCampaignLazy,
  CreateNewCompanyLazy,
  CreateRoleLazy,
  DashboardLazy,
  EditCampaignLazy,
  ForgetPwdLazy,
  LoginLazy,
  LogoutLazy,
  RegisterLazy,
  ResetPasswordLazy,
  RolesLazy,
  SettingsLazy,
  SourceSettingLazy,
  ForbiddenLazy,
  UserProfileLazy,
  UsersLazy,
  AdminUsersLazy,
  ScheduledReportListLazy,
  AdminScheduledReportListLazy,
  AdminScheduledReportLogLazy,
  FeaturesFlagsLazy,
  AdminLoginLazy,
  AdminSignupLazy,
  AdminUserProfileLazy,
  AdminUserRolesLazy,
  AdminInternalUserLazy,
  ResetAdminUserPasswordLazy,
  EditAdminUserRoleLazy,
  AdminUserForgotPasswordLazy,
  NotificationsLazy,
  UnlockAdminUserAccountLazy,
  EmailEventsLazy,
  ReportExportsLazy,
  ProfilesLazy,
  InvoicesLazy,
  ReceiptsLazy,
  ScheduledReportLogLazy,
  CampaignAnalysisLazy,
  CampaignAnalysisLeadsCallsLazy,
  IntegrationsLazy,
  CreateIntegrationLazy,
  EditIntegrationLazy,
  LeadsPageLazy,
  LeadDetailPageLazy,
  CallsPageLazy,
  ParsedCallDetailsLazy,
  CallLeadSourceSettingLazy,
  ClickConversionLogsLazy,
  AdminNotificationTemplatesLazy,
  EditAdminNotificationTemplatesLazy,
  AdminNotificationsLazy,
  IntegrationLogLazy,
  ClientEmailEventsLazy,
  InsuranceCarriersLazy,
  UserActivityLazy,
  AdminRefundReasonsLazy,
  AdminPaymentTermsLazy,
  AdminBillingEventsLazy,
  TermsOfServicesLazy,
  ClientTermsOfServicesLazy,
  AdminTwilioNumbersLazy,
  AdminLeadPricesLazy,
  AdminCallPricesLazy,
  AdminLeadRefundsLazy,
  WhitelistedBrandsLazy,
  WhitelistedBrandsUsersLazy,
  AdminSfClicksFiltersLazy,
  AdminSfCallsFiltersLazy,
  AdminSfLeadsFiltersLazy,
  AdminCallFilterPackagesLazy,
  AdminLeadFilterPackagesLazy,
  quoteFunnelAnswersFlagsLazy,
  QuoteFunnelLazy,
  quoteFunnelReviewFlagsLazy,
  ConversionUploadDetailsLazy,
  QuoteFunnelPreviewLazy,
  termsOfUseLazy,
  privacyPolicyQFLazy,
  SMSTermsQFLazy,
  CCPAPolicyQFLazy,
  ProspectPageLazy,
  CPAOptimizerLazy,
  ProspectDetailPageLazy,
  CreatePasswordLazy,
  ConversationsPageLazy,
  DevDashboardPageLazy,
  ReportingConsistencyPageLazy,
  DmsDashobardPageLazy,
  RulesDashobardPageLazy,
  ReceiptTypesTermsLazy,
  StatusMonitorPageLazy,
  CustomerIncidentsPageLazy,
  AutomationTestsPageLazy,
  RdsMonitorPageLazy,
  DataSciencePageLazy,
  AdminIntegrationLogsLazy,
  AdminBulkMigrationLazy,
  RefundPoliciesLazy,
  AdminCampaignFulFillmentLazy,
  MiloDashboardLazy,
  CampaignFulfillmentLazy
} from "pages/lazyPages/sfLazyPages"

import RegisterCheck from "components/Common/RegisterCheck"
import NotificationsTerminal from "pages/NotificationsTerminal/NotificationsTerminal";
import RegistrationWithCampaignCreation from "pages/Authentication/RegistrationWithCampaignCreation";
import RegistrationWithCampaignCreationPrompt from "pages/Authentication/RegistrationWithCampaignCreationPrompt";
import BillingRegistrationWrapper from "pages/Authentication/BillingRegistrationWrapper";
import ThankYouQuoteFunnelAnswer from "pages/QuoteFunnelAnswer/ThankYouQuoteFunnelAnswer";
import AdminDashboardWrapper from "pages/Admin/DashboardRevamp/AdminDashboardWrapper"

// Authentication related pages

// Dashboard

const authProtectedRoutes = [
  { path: "/", exact: true, component: () => <Redirect to="/dashboard" /> },
  { path: "/dashboard", component: DashboardLazy },
  { path: "/reporting-consistency", component: ReportingConsistencyPageLazy },

  // //profile
  { path: "/profile", component: UserProfileLazy },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name

  { path: "/dashboard", component: DashboardLazy },
  { path: "/company/create", component: CreateNewCompanyLazy },
  { path: "/roles", component: RolesLazy },
  { path: "/users", component: UsersLazy },
  { path: "/analytics/scheduled_report_logs/:scheduled_report_id", component: ScheduledReportLogLazy, exact: true },
  { path: "/analytics/scheduled_reports", component: ScheduledReportListLazy },
  { path: "/roles/create", component: CreateRoleLazy },
  { path: "/roles/update/:role_id", component: CreateRoleLazy },
  { path: "/campaigns", component: CampaignsPageLazy },
  { path: "/leads", component: LeadsPageLazy },
  { path: "/calls", component: CallsPageLazy },
  { path: "/campaigns/create", component: CreateCampaignLazy },
  { path: "/campaigns/:campaign_id/edit", component: EditCampaignLazy },
  { path: "/campaigns/:campaign_id/summary", component: CampaignSummaryLazy },
  { path: "/leads/:lead_id", component: LeadDetailPageLazy },
  { path: "/prospects/:lead_id", component: ProspectDetailPageLazy },
  { path: "/calls/parsed/:quote_call_id", component: ParsedCallDetailsLazy },
  { path: "/calls/:lead_id", component: LeadDetailPageLazy },
  { path: "/campaigns/:campaign_id/adgroups", component: AdGroupsLazy },
  { path: "/campaigns/:campaign_id/profiles", component: ProfilesLazy },
  { path: "/email-activity", component: ClientEmailEventsLazy },
  { path: "/quote_funnels", component: QuoteFunnelLazy },
  { path: "/prospects", component: ProspectPageLazy },
  { path: "/cpa-optimizer", component: CPAOptimizerLazy },
  { path: "/conversations", component: ConversationsPageLazy },
  {
    path: "/campaigns/:campaign_id/source-setting",
    component: SourceSettingLazy,
  },
  {
    path: "/campaigns/:campaign_id/call-lead-source-setting",
    component: CallLeadSourceSettingLazy
  },
  {
    path: "/campaigns/:campaign_id/campaign-analysis",
    component: CampaignAnalysisLazy
  },
  {
    path: "/campaigns/:campaign_id/leads-calls-campaign-analysis",
    component: CampaignAnalysisLeadsCallsLazy
  },
  { path: "/creatives", component: AllCreativesLazy },
  { path: "/creatives/create", component: AddNewCreativeLazy },
  { path: "/creatives/edit/:creative_id", component: AddNewCreativeLazy },
  { path: "/history", component: ChangeLogsLazy },
  { path: "/settings", component: SettingsLazy },
  { path: "/terms_of_services", component: ClientTermsOfServicesLazy },
  { path: "/analytics", component: AnalyticsLazy },
  { path: "/billings", component: BillingLazy },
  { path: "/forbidden", component: ForbiddenLazy },
  { path: "/notifications", component: NotificationsLazy },
  { path: "/integrations", component: IntegrationsLazy },
  { path: "/integrations/create", component: CreateIntegrationLazy },
  { path: "/integrations/edit/:integration_id", component: EditIntegrationLazy },
  { path: "/settings/:brand_id/click-conversion-uploads", component: ClickConversionLogsLazy },
  { path: "/settings/:brand_id/click-conversion-uploads/details/:click_conversion_log_id", component: ConversionUploadDetailsLazy },
  { path: "/integrations/log/:integration_log_id", component: IntegrationLogLazy, exact: true },
  { path: "/campaigns/:campaign_id/campaign-fulfillment", component: CampaignFulfillmentLazy },


  //Page not found
  { path: "*", component: Notfound },
]

const publicRoutes = [
  { path: "/login", component: LoginLazy },
  { path: "/logout", component: LogoutLazy },

  { path: "/forgot-password", component: ForgetPwdLazy },
  { path: "/register", component: RegisterLazy },
  //TODO: Change this in the server instead
  { path: "/api/v1/password/edit", component: ResetPasswordLazy },
  { path: "/api/v1/password/new", component: CreatePasswordLazy },
  { path: "/register/billing-information", component: RegisterCheck },
  { path: "/register/billing-registration", component: BillingRegistrationWrapper },
  { path: "/register/create-campaign", component: RegistrationWithCampaignCreation },
  { path: "/register/create-campaign-prompt", component: RegistrationWithCampaignCreationPrompt },
  { path: "/forms/thank_you/session/:session_id", component: ThankYouQuoteFunnelAnswer },
  { path: "/forms/review/session/:session_id", component: quoteFunnelReviewFlagsLazy },
  { path: "/forms/session/:session_id", component: quoteFunnelAnswersFlagsLazy, exact: true },
  { path: "/forms/quote_form/:quote_funnel_id", component: quoteFunnelAnswersFlagsLazy, exact: true },
  { path: "/forms/campaign/:campaign_id", component: quoteFunnelAnswersFlagsLazy, exact: true },
  { path: "/terms-of-use", component: termsOfUseLazy, exact: true },
  { path: "/privacy-policy", component: privacyPolicyQFLazy, exact: true },
  { path: "/sms-terms", component: SMSTermsQFLazy, exact: true },
  { path: "/ccpa-opt-out", component: CCPAPolicyQFLazy, exact: true },
]

const fullWidthRoutes = [
  { path: "/quote_funnel_preview", component: QuoteFunnelPreviewLazy },
]

const adminPublicRoutes = [
  { path: "/login", component: AdminLoginLazy },
  { path: "/admin_signup", component: AdminSignupLazy },
  {
    path: "/api/v1/admin_password/edit",
    component: ResetAdminUserPasswordLazy,
  },
  { path: "/admin-forgot-password", component: AdminUserForgotPasswordLazy },
  { path: "/api/v1/admin_unlock", component: UnlockAdminUserAccountLazy },
]

const adminUserAuthProtectedRoutes = [
  { path: "/", exact: true, component: () => <Redirect to="/dashboard" /> },
  { path: "/admin_profile", component: AdminUserProfileLazy },
  { path: "/client-users", component: AdminUsersLazy },
  { path: "/whitelabeled_brands", component: WhitelistedBrandsLazy },
  { path: "/whitelabeled_brands_users", component: WhitelistedBrandsUsersLazy },
  { path: "/dashboard", component: AdminDashboardWrapper },
  { path: "/scheduled_reports", component: AdminScheduledReportListLazy },
  { path: "/scheduled_report_logs/:admin_scheduled_report_id", component: AdminScheduledReportLogLazy, exact: true },
  { path: "/feature-flags", component: FeaturesFlagsLazy },
  { path: "/admin_user_roles", component: AdminUserRolesLazy },
  { path: "/admin_notification_templates", component: AdminNotificationTemplatesLazy },
  { path: "/admin_internal_user", component: AdminInternalUserLazy },
  { path: "/admin_create_user_role", component: EditAdminUserRoleLazy },
  { path: "/admin_notification_templates/create", component: EditAdminNotificationTemplatesLazy },
  { path: "/admin_notification_templates/edit/:admin_template_id", component: EditAdminNotificationTemplatesLazy },
  { path: "/admin_notifications", component: AdminNotificationsLazy },
  { path: "/admin_change_history", component: AdminChangeLogsLazy },
  {
    path: "/admin_user_roles/admin_update_user_role/:admin_role_id",
    component: EditAdminUserRoleLazy,
  },
  { path: "/email-activity", component: EmailEventsLazy },
  { path: "/report-exports", component: ReportExportsLazy },

  { path: "/forbidden", component: ForbiddenLazy },
  { path: "/accounting/invoices", component: InvoicesLazy },
  { path: "/accounting/receipts", component: ReceiptsLazy },
  { path: "/notifications_terminal", component: NotificationsTerminal },
  { path: "/insurance_carriers", component: InsuranceCarriersLazy },
  { path: "/user_activity", component: UserActivityLazy },
  { path: "/terms_of_services", component: TermsOfServicesLazy },
  { path: "/refund_reasons", component: AdminRefundReasonsLazy },
  { path: "/accounting/payment_terms", component: AdminPaymentTermsLazy },
  { path: "/accounting/billing_events", component: AdminBillingEventsLazy },
  { path: "/accounting/receipt_types", component: ReceiptTypesTermsLazy },
  { path: "/twilio_numbers", component: AdminTwilioNumbersLazy },
  { path: "/admin_lead_prices", component: AdminLeadPricesLazy },
  { path: "/admin_call_prices", component: AdminCallPricesLazy },
  { path: "/admin_lead_refunds", component: AdminLeadRefundsLazy },
  { path: "/admin/clicks/sf_filters", component: AdminSfClicksFiltersLazy },
  { path: "/admin/calls/sf_filters", component: AdminSfCallsFiltersLazy },
  { path: "/admin/leads/sf_filters", component: AdminSfLeadsFiltersLazy },
  { path: "/admin/calls/filter_packages", component: AdminCallFilterPackagesLazy },
  { path: "/admin/leads/filter_packages", component: AdminLeadFilterPackagesLazy },
  { path: "/dev-dashboard", component: DevDashboardPageLazy },
  { path: "/reporting-consistency", component: ReportingConsistencyPageLazy },
  { path: "/dms-dashboard", component: DmsDashobardPageLazy },
  { path: "/rules-dashboard", component: RulesDashobardPageLazy },
  { path: "/status-monitor", component: StatusMonitorPageLazy },
  { path: "/status-monitor/customer-incidents", component: CustomerIncidentsPageLazy },
  { path: "/automation-tests", component: AutomationTestsPageLazy },
  { path: "/rds-monitor", component: RdsMonitorPageLazy },
  { path: "/data-science-dashboard", component: DataSciencePageLazy },
  { path: "/admin_lead_integrations_logs", component: AdminIntegrationLogsLazy },
  { path: "/admin_bulk_migration", component: AdminBulkMigrationLazy },
  { path: "/admin_bulk_edit_jobs", exact: true, component: () => <Redirect to="/admin_bulk_migration" /> },
  { path: "/admin_integration_logs/:integration_log_id", component: IntegrationLogLazy },
  { path: "/refund_policies", component: RefundPoliciesLazy },
  { path: "/admin_campaign_fulfillment", component: AdminCampaignFulFillmentLazy },
  { path: "/milo", component: MiloDashboardLazy },
  { path: "*", component: Notfound },
]

export {
  publicRoutes,
  authProtectedRoutes,
  adminPublicRoutes,
  adminUserAuthProtectedRoutes,
  fullWidthRoutes
}
